import { render, staticRenderFns } from "./SignatureTemplate2.vue?vue&type=template&id=eb99612a&"
import script from "./SignatureTemplate2.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports